import type { HtmlFrameThemeMode } from "./editable-html-iframe";

export const HTML_FRAME_THEME_LABEL_KEY = {
  app: "themeApp",
  light: "themeLight",
  dark: "themeDark",
} as const satisfies Record<HtmlFrameThemeMode, string>;

export const HTML_FRAME_THEME_METADATA_KEY = "html_frame_theme_mode";

function isHtmlFrameThemeMode(value: unknown): value is HtmlFrameThemeMode {
  return value === "app" || value === "light" || value === "dark";
}

export function getInitialThemeMode(
  metadata: Record<string, unknown>,
): HtmlFrameThemeMode {
  const stored = metadata[HTML_FRAME_THEME_METADATA_KEY];
  if (isHtmlFrameThemeMode(stored)) return stored;
  return "app";
}

function isAppThemeDark(): boolean {
  if (typeof document === "undefined") return true;
  return document.documentElement.classList.contains("dark");
}

export function getNextThemeMode(
  current: HtmlFrameThemeMode,
): HtmlFrameThemeMode {
  if (current !== "app") return "app";
  return isAppThemeDark() ? "light" : "dark";
}
